<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import formProdutoEstoque from '@/src/components/form-produto-estoque'

import Produto from '@/src/services/produto_estoque'
import moment from 'moment'
moment.locale('pt-br')

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading, formProdutoEstoque },
  data() {
    return {
      mostraForm: true,
      produtoEdit: {},
      produtos: [],
      produtosSelect: [],
      produtoFields: [
        {
          key: 'nome',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'valor_venda',
          label: 'Valor Venda',
          class: 'size-col-20',
        },
        {
          key: 'custo_medio',
          label: 'Custo Médio',
          class: 'size-col-20',
        },
        {
          key: 'data_cadastro',
          label: 'Data de entrada',
          class: 'size-col-20',
        },        
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
      isLoading: false,
      idProduto: '',
      filter: '',
      rows: 0,
    }
  },
  computed: {},

  watch: {
    currentPage() {
      this.listar()
    },
  },
  mounted() {
    this.listar()
    this.produtoEdit.if_nf = false;
  },
  methods: {
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    listar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      Produto.listarNotFilter(token, this.perPage, this.currentPage)
        .then((resposta) => {
          this.produtos = resposta.data.produtos || []
          this.rows = resposta.data.count || 0
        })
        .catch(() => {
          this.produtos = []
          this.rows = 0
          this.$bvToast.toast('Não foi possível listar os produtos.', {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    editRegister(empresa) {
      this.produtoEdit = empresa
      this.mostraForm = false
    },
    cancelarCadastro() {
      this.mostraForm = true
      this.listar()
    },
    salvarProduto(resetAfterSave = false) {
      if (this.$refs.formProduto && this.$refs.formProduto.salvarProduto) {
        this.$refs.formProduto.salvarProduto(resetAfterSave)
      }
    },
    handleProdutoSalvo({ resetAfterSave }) {
      if (!resetAfterSave) {
        this.mostraForm = true
        this.listar()
      }
    },
    cadastra() {
      if (this.produtoEdit) {
        this.produtoEdit = {}
      }
      if (this.mostraForm === true) {
        this.mostraForm = false
        this.produtoEdit.ativo = true        
      } else {
        this.mostraForm = true
        this.listar()
      }
    },
    modalDelete(id) {
      this.$bvModal.show('modal-delete')
      this.idProduto = id
    },
    async Deletar() {
      const token = this.$store.state.auth.currentUser.token
      const idProduto = this.idProduto
      this.isLoading = true

      try {
        await Produto.deletar(token, idProduto)
        await this.listar()
      } catch (err) {
        const mensagem =
          err.response && err.response.data && Array.isArray(err.response.data.data)
            ? err.response.data.data.join(', ')
            : 'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.'

        this.$bvToast.toast(mensagem, {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } finally {
        this.isLoading = false
      }

      this.idProduto = null
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row align-items-start">
          <div class="col-md-7">
            <div class="titulo">
              {{ mostraForm ? 'Produtos' : 'Cadastro de Produto' }}
            </div>
            <div class="subTitulo">
              <span v-if="mostraForm">Gerencie os produtos cadastrados no estoque.</span>
              <span v-else>
                Cadastre produtos, preços, estoque, fornecedores, dados fiscais e informações específicas para controle comercial, agrícola e pet shop.
              </span>
            </div>
          </div>
          <div class="col-md-5">
            <div class="product-page-actions">
              <button v-if="mostraForm" class="btn btn-primary" @click="cadastra">
                <i class="uil uil-plus"></i>
                Novo Produto
              </button>
              <template v-else>
                <button class="btn btn-outline-secondary" @click="cancelarCadastro">
                  Cancelar
                </button>
                <button class="btn btn-outline-primary" @click="salvarProduto(true)">
                  <i class="uil uil-plus"></i>
                  Salvar e Novo
                </button>
                <button class="btn btn-primary" @click="salvarProduto(false)">
                  <i class="uil uil-save"></i>
                  Salvar
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div class="row" v-if="mostraForm">
         <div class="col-md-4">
          <b-form-group id="input-group-1" label="Descrição" label-for="filter">
            <b-form-input
              id="filter"
              v-model="filter"
              type="text"
              placeholder="Digite o filtro de busca"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div>
        <div v-if="mostraForm">
          <div class="col-md-12">
            <div class="float-right">
              <div class="description found"><b>Total de Registros: {{ this.rows }}</b> </div>
            </div>
          </div>
          
          <b-table
            striped
            hover
            responsive="sm"
            borderless
            bordered
            outlined
            small
            :items="produtos"
            :fields="produtoFields"
            :per-page="perPage"
            :filter="filter"
            show-empty
          >
            <template #empty="scope">
              <div class="row">
                <div class="col-md-12">
                  <span>Nenhum produto encontrado!</span>
                </div>
              </div>
            </template>
            <template v-slot:cell(data_cadastro)="row">
            {{
              formatDate(row.item.data_cadastro) !== 'Invalid date'
                ? formatDate(row.item.data_cadastro)
                : row.item.data_cadastro
            }}
          </template>
            <template v-slot:cell(actions)="row">
              <div class="btn-group mb-2">
                <button
                  v-b-tooltip.hover
                  title="Editar"
                  type="button"
                  class="btn btn-light"
                  @click="editRegister(row.item)"
                >
                  <i class="uil uil-edit"></i>
                </button>
                <button
                  v-b-tooltip.hover
                  title="Deletar"
                  type="button"
                  class="btn btn-light"
                  @click="modalDelete(row.item.id_produto)"
                >
                  <i class="uil uil-trash-alt"></i>
                </button>
              </div>
            </template>
            <template v-slot:cell(ativo)="row">{{
              row.item.ativo ? 'Sim' : 'Não'
            }}</template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            size="md"
            :total-rows="rows"
            :per-page="perPage"
          ></b-pagination>
        </div>

        <div v-else>
          <formProdutoEstoque ref="formProduto" :produto="produtoEdit" @onSave="handleProdutoSalvo" />
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-delete')"
          >Não</b-button
        >
        <b-button variant="danger" @click="Deletar">Sim</b-button>
      </template>
    </b-modal>
    <loading
      :active.sync="isLoading"
      color="#008e75"
      :can-cancel="false"
    ></loading>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.product-page-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  .btn {
    min-width: 132px;
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border-radius: 6px;
    font-weight: 700;
  }

  .btn-primary {
    border-color: #008e75;
    background-color: #008e75;
  }

  .btn-outline-primary {
    border-color: #cbd8df;
    color: #0f1f33;
    background: #fff;

    &:hover {
      border-color: #008e75;
      color: #008e75;
      background: #f2fbf8;
    }
  }

  .btn-outline-secondary {
    border-color: #cbd8df;
    color: #0f1f33;
    background: #fff;

    &:hover {
      background: #f4f7f9;
      color: #0f1f33;
    }
  }
}

@media (max-width: 768px) {
  .product-page-actions {
    justify-content: flex-start;
    margin-top: 16px;

    .btn {
      flex: 1 1 100%;
    }
  }
}
</style>
